import { useMachineAPI } from "../../api/machine/useMachineAPI";
import { machineActions } from "./MachineReducer";

export const useMachine = () => {
    const api = useMachineAPI();
  
    const request = {
        get: (params) => {
          return async (dispatch) => {
            try {
              const response = await api.machine.get(params);
              dispatch(machineActions.funGetMachine(response));
            } catch (error) {
              console.error('Error fetching machine data:', error);
            }
          }
        },
        post: async (data) => {
          return await api.machine.post(data);
        },
        put: async (data) => {
          return await api.machine.put(data);
        },
        delete: async (params) => {
          return await api.machine.delete(params);
        }
    };
    return { request };
  };